import type { EntityDocument } from '../components/documents/DocumentList'

export function normalizeVehicleDocumentsPayload(raw: unknown): unknown[] {
  if (raw == null) {
    return []
  }
  if (Array.isArray(raw)) {
    return raw
  }
  if (typeof raw !== 'object') {
    return []
  }
  const o = raw as Record<string, unknown>
  if ('success' in o && o.data !== undefined) {
    return normalizeVehicleDocumentsPayload(o.data)
  }
  if (Array.isArray(o.data)) {
    return o.data
  }
  if (Array.isArray(o.documents)) {
    return o.documents
  }
  if (o.data && typeof o.data === 'object' && !Array.isArray(o.data)) {
    const inner = o.data as Record<string, unknown>
    if (Array.isArray(inner.documents)) {
      return inner.documents
    }
  }
  return []
}

type VehicleRegistryDocFile = Record<string, unknown>

function fileUrlFromEntry(f: VehicleRegistryDocFile): string {
  const u =
    (typeof f.fileUrl === 'string' && f.fileUrl) ||
    (typeof f.file_url === 'string' && f.file_url) ||
    ''
  return u
}

function fileNameFromEntry(f: VehicleRegistryDocFile): string {
  const n =
    (typeof f.fileName === 'string' && f.fileName) ||
    (typeof f.file_name === 'string' && f.file_name) ||
    ''
  return n
}

type VehicleRegistryDoc = {
  id: string
  name?: string
  type?: string | null
  expiryDate?: string | Date | null
  createdAt?: string
  uploader?: { id: string; name: string; email: string }
  files?: VehicleRegistryDocFile[]
}

export function mapVehicleRegistryDocumentsToEntityList(raw: unknown): EntityDocument[] {
  const list = normalizeVehicleDocumentsPayload(raw)
  if (!Array.isArray(list)) {
    return []
  }
  return list.map((item) => {
    const d = item as VehicleRegistryDoc
    const filesRaw = d.files
    const files = Array.isArray(filesRaw) ? filesRaw : []
    let url = ''
    let fileLabel = ''
    if (files.length > 0) {
      const f = files[0] as VehicleRegistryDocFile
      url = fileUrlFromEntry(f)
      fileLabel = fileNameFromEntry(f)
    }
    const name =
      fileLabel ||
      (typeof d.name === 'string' && d.name) ||
      'Document'
    const createdAt =
      typeof d.createdAt === 'string' ? d.createdAt : new Date().toISOString()
    let expiryDate: string | undefined
    if (d.expiryDate != null) {
      expiryDate =
        typeof d.expiryDate === 'string' ? d.expiryDate : d.expiryDate.toISOString()
    }
    return {
      id: d.id,
      name,
      url,
      type: d.type ?? undefined,
      expiryDate,
      uploadedBy: d.uploader,
      createdAt,
    }
  })
}
